import React, { useState, useEffect, useContext } from "react";
import {Accordion, AccordionSummary, AccordionDetails, Typography, List, ListItem, Box, ListItemText, Link } from '@mui/material';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {properties} from "../../utils/properties";
import {updateSedute} from "./Utils";
import {ThreeDots} from 'react-loader-spinner';
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { IconButton } from '@mui/material';
import SweetAlert from "react-bootstrap-sweetalert";
import axios from 'axios';
import PublishIcon from '@mui/icons-material/Publish';

export default function ArchivioVerbali() {        
    const color="#666999";
    const navigate = useNavigate();
    const [loadingGen, setLoadingGen] = React.useState(false);   
    const [meetingData, setMeetingData] = useState([]);
    const [openedYear, setOpenedYear] = useState([]);
    const [alert, setAlert] = React.useState(null);
    
    const [notificationAvailable, setNotificationAvailable] = useState(null);
  const [dialog, setDialog] = useState(null);
  

  const handleNotificationAvailable = (dateString,textString, id) => {    
      //console.log("HNA",dateString, textString);
    return new Promise((resolve) => {

      const handleChoice = (choice, id) => {
        console.log("called", choice, id);
        var xhr = new XMLHttpRequest();                        
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/updateStatoFieldUser.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {                                                    
                      console.log("OK",xhr);                      
                      const response = JSON.parse(xhr.responseText);
                      setDialog(null);
                      resolve(choice);
                        
                }
              }        
        };

        xhr.onerror = function (e) {
            console.error("Error 27", xhr);
            //localStorage.clear();          
            setDialog(null);
            resolve(choice);  
            navigate("/login");
        };
       
      let urlEncodedData = "id=" + id+ "&value=" + choice;  
      xhr.send(urlEncodedData);
      };

    setDialog(      
      <Dialog open={true} 
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          handleChoice(0,id); 
        }        
      }}
      fullWidth maxWidth="sm">
              <DialogTitle sx={{ textAlign: "center" }}>
              {dateString}
              </DialogTitle>
              <DialogContent dividers>
                <Typography sx={{ textAlign: "justify", fontSize: 18 }}>
                  {textString}
                </Typography>
              </DialogContent>
              <DialogActions sx={{ flexDirection: "column", gap: 1, alignItems: "stretch", p: 2 }}>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }}  variant="contained" color="success"  onClick={() => handleChoice(1,id)}>✅ CONFERMO LA PARTECIPAZIONE IN PRESENZA</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="success"  onClick={() => handleChoice(2,id)}>💻 CONFERMO LA PARTECIPAZIONE DA REMOTO</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="inherit" onClick={() => handleChoice(4,id)}>⏳ NON SO ANCORA, RICORDAMELO PIU' TARDI</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="inherit"  onClick={() => handleChoice(3,id)}>❌ NON RIESCO A PARTECIPARE ALLA SEDUTA</Button>
              </DialogActions>
      </Dialog>
      );
    });

  }



useEffect(() => {
  
  if (localStorage.getItem("ruolo") !== "2" && localStorage.getItem("ruolo") !== "20" && localStorage.getItem("ruolo") !== "21") {  
      const scelta="nessunaNotifica";
      setNotificationAvailable(scelta);
  }
  else{  
      let mounted = true;
      const run = () => {
        const xhr = new XMLHttpRequest();
        const url = properties.productionUrl + properties.productionUrlSuffix + "/core/rest/checkNotifications.php";

        xhr.open("POST", url, true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = async function () {
          console.log("POST",xhr.readyState,xhr.status);
          if (xhr.readyState === 4 && xhr.status === 200) {
            try {
              const obj = JSON.parse(xhr.responseText);
              console.log("ID",obj.id)
              if (!mounted) return;
              
              const scelta = await handleNotificationAvailable(obj.date ?? "", obj.text ?? "", obj.id ?? "");
              console.log("Scelta utente:", scelta);

              if (!mounted) return;
              if (scelta != null) setNotificationAvailable(scelta);
            } catch (err) {
              console.error("JSON parsing error:", err);
            }
          }
          if (xhr.readyState === 4 && xhr.status === 404) {
            //NO NOTIFICHE
            const scelta="nessunaNotifica";
            setNotificationAvailable(scelta);
          }

        };

        xhr.onerror = function () {
          console.error("XHR network error");
        };

        xhr.send(null);
      };
      run();


  return () => {
    mounted = false;
  };
}
}, []);

    const topicList = (item) => {
        if( properties.verboseLog==1)
            console.log("CLICK", item.id);
        if(item.lastUpdate){ 
            if (item.id.length==8){
                var x=item.id;                                
                var url= "CdG"+x.substring(4,8)+x.substring(2,4)+x.substring(0,2)+".pdf";
                url=properties.productionUrl+"/fileManager/files/verbaliCollegio/"+url;
                if( properties.verboseLog==1)
                    console.log(url);
                window.open(url);
            }             
        }      
    };

    const doPostSedute2 = function() {
    if( properties.verboseLog==1)
        console.log("doing sedute post");
    if (!loadingGen) { setLoadingGen(true);} 
    var xhr2 = new XMLHttpRequest();                        
    xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/checkSeduteJsonCollegio.php',true);
    xhr2.withCredentials = true;
    xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
    xhr2.onload = function (e) {      
        if (xhr2.readyState === 4) {
            if (xhr2.status === 200) {                              
                if( properties.verboseLog==1)
                    console.log("OK DOPOSTSEDUTE",xhr2);
                var responseText = xhr2.responseText;                    
                var obj=JSON.parse(responseText);
                if( properties.verboseLog==1)
                    console.log("OK93",obj);          
                if(obj.status==="204" ){                         
                        console.log("OK VERBALIAPPROVATI 204",xhr2);
                    const jsonListSedute = JSON.parse(localStorage.getItem("listSedute"));                    
                    updateUI(jsonListSedute);
                }              
                else{
                    //status 201
                    console.log("OK VERBALIAPPROVATI 201",xhr2);                            
                    try{
                        localStorage.setItem("listSeduteVersion", obj.date);          
                        localStorage.setItem("listSedute", obj.content);                                                                                                                                                          
                    }
                    catch(error) {
                        console.log("LOCALSTORAGE ISSUE", error);
                    }                           
                    const jsonListSedute = JSON.parse(obj.content);
                    updateUI(jsonListSedute);
                }
                setLoadingGen(false); 
            } 
            else {                    
                setLoadingGen(false);
                window.alert("Errore recuperando la seduta");  
            }
        }
    };

    xhr2.onerror = function (e) {
        setLoadingGen(false);
        console.error("Error 22", xhr2.statusText);
    };
    
    let urlEncodedData = null; //"idf=" + meetingId;
    if (localStorage.listSedute!=='' &&localStorage.listSedute!==undefined){            
        if( properties.verboseLog==1)
            console.log( "QUINDI00");
        const currentData=localStorage.getItem("listSeduteVersion");        
        urlEncodedData = "date=" + currentData;                    
    }            
    xhr2.send(urlEncodedData);
    }

    const showAlert = () => {
        if( properties.verboseLog==1)
            console.log("showing alert");    
        setAlert(
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
            title={"Impossibile caricare il file selezionato. Verificare che si tratti di un file in formato pdf e riprovare. Se il problema si riproponesse, contattare l'amministratore. " }
            text="Attenzione"          
            onConfirm={() => { setAlert(null) }}          
            confirmBtnCssClass="custom-btn custom-btn-success" 
            cancelBtnCssClass="custom-btn custom-btn-cancel"          
            confirmBtnText="Indietro"          
        >
        </SweetAlert>
        );
    };

    const onFileChange= (e,item ) => {   
        if( properties.verboseLog==1){
            console.log("ew3",e); 
            console.log("ew4",item);
            console.log("ONFILE CHANGE INIT ",loadingGen);  
        }
        if (!loadingGen) { setLoadingGen(true);} 
        if( properties.verboseLog==1)
            console.log("ONFILE CHANGE ",loadingGen);
        e.stopPropagation(); 
         
        let endpoint = properties.productionUrl+properties.productionUrlSuffix+"/core/rest/updateVerbaliCollegio.php";  
        let file=e.target.files[0];
        
        var bodyFormData=new FormData();            
        bodyFormData.append('UploadedFile', file);                
        bodyFormData.append('idf', item.id);
        if( properties.verboseLog==1)
            console.log("PARAM",bodyFormData);
        axios({
            method: 'post',
            url: endpoint,
            data: bodyFormData, 
            withCredentials: true, 
            headers: {'Content-Type': 'multipart/form-data' }
        })
        .then(function (response) {    
            if( properties.verboseLog==1)
                console.log("ONFILE CHANGE THEN ",loadingGen);                    
            setLoadingGen(false);
            if( properties.verboseLog==1){
                console.log("ONFILE CHANGE THEN ",loadingGen);                    
                console.log(response);
            }
            e.target.files=null;
            e.target.value=null;
            doPostSedute2();
        })
        .catch(function (response) {        
            console.log("ONFILE CHANGE CATCH ",loadingGen);  
            if( properties.verboseLog==1)
                console.log(response);
            setLoadingGen(false);
            if( properties.verboseLog==1)
                console.log("ONFILE CHANGE CATCH ",loadingGen);  
            showAlert();
        }); 
    
    };

    const handleChange = (anno) => {
        setOpenedYear((prev) =>(
            //DA USARE SE VOGLIO UN SOLO ELEMENTO DELL'ACCORDION ESPANSO ALLA VOLTA
            //Object.fromEntries(
            //Object.keys(prev).map((key) => [key, key === anno && !prev[key]])
            {...prev,
            [anno]: !prev[anno],}
        )
  );
      };

    /*  
    function raggruppaPerAnno(array) {
        const documentiPerAnno = {};
        var openedYear = {};
        
        array.forEach(item => {
          if (!item.date) return; 
      
          const [giorno, mese, anno] = item.date.split("/");
      
          if (!documentiPerAnno[anno]) {
            documentiPerAnno[anno] = [];
          }
          if (!openedYear[anno]) {
            openedYear[anno] = false;
          }
          documentiPerAnno[anno].push({
            id:item.id,
            nome: item.date,
            order: item.order,
            ...(item.lastUpdate && { lastUpdate: item.lastUpdate })
          });
        });
        if( properties.verboseLog==1){
            console.log("DPA",documentiPerAnno,Object.entries(documentiPerAnno));              
            console.log("OY",openedYear);
        }   
        openedYear= Object.fromEntries(
                Object.entries(openedYear)
                  .sort(([a], [b]) => b - a) // ordina decrescente
                  .map(([anno], index) => [anno, index === 0]) // setta true solo al primo (il più recente)
              );
       
        setMeetingData(documentiPerAnno);
        setOpenedYear(openedYear)
        if( properties.verboseLog==1)
            console.log("OY2",openedYear);
        return documentiPerAnno;
      }
    */
      function raggruppaPerAnno(array) {
        const documentiPerAnno = {};
        let openedYear = {};
      
        array.forEach(item => {
          if (!item.date) return;
      
          const [giorno, mese, anno] = item.date.split("/");
      
          if (!documentiPerAnno[anno]) {
            documentiPerAnno[anno] = [];
          }
          if (!openedYear[anno]) {
            openedYear[anno] = false;
          }
      
          documentiPerAnno[anno].push({
            id: item.id,
            nome: item.date,
            order: item.order,
            ...(item.lastUpdate && { lastUpdate: item.lastUpdate }),
            _timestamp: new Date(`${anno}-${mese}-${giorno}`).getTime()
          });
        });
      
        // Ordina ogni array per anno in ordine decrescente di data
        Object.keys(documentiPerAnno).forEach(anno => {
          documentiPerAnno[anno].sort((a, b) => b._timestamp - a._timestamp);
          // Rimuove il campo temporaneo
          documentiPerAnno[anno] = documentiPerAnno[anno].map(({ _timestamp, ...rest }) => rest);
        });
      
        // Ordina gli anni (chiave) in modo decrescente
        openedYear = Object.fromEntries(
          Object.entries(openedYear)
            .sort(([a], [b]) => b - a) // decrescente per anno
            .map(([anno], index) => [anno, index === 0]) // true solo per il più recente
        );
      
        if (properties.verboseLog == 1) {
          console.log("DPA", documentiPerAnno, Object.entries(documentiPerAnno));
          console.log("OY", openedYear);
        }
      
        setMeetingData(documentiPerAnno);
        setOpenedYear(openedYear);
        console.log("RET",documentiPerAnno);
        return documentiPerAnno;
      }
    

    const doPostVerbali = function(listaSedute) {
    if( properties.verboseLog==1)
        console.log("doing sedute post");
        var xhr2 = new XMLHttpRequest();                
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/test01Collegio.php',true);
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {
            if(xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                                                            
                    if(responseText!="\n\nnull"){
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1){
                        console.log("ho tutte le info ON DOPOSTVERBALI",obj);
                        console.log("LISTA SEDUTE",listaSedute);
                        console.log("FILES",obj);
                    }                                        
                    var alfa=obj.split(/\r?\n/);
                    for(var d=1; d< alfa.length;d++) {                        
                        var beta= alfa[d].split(' ');
                        beta=beta.filter(String);
                        var val="";
                        for (var r=7;r < beta.length;r++){
                            val=val+" "+beta[r];
                        }
                        val=val.trim();
                        var found=false;
                        
                        if(beta[7]!= undefined) {
                            if(!beta[7].includes("approvazione")){                     
                                var tmp22= beta[7].substring(9,11).concat(beta[7].substring(7,9)).concat(beta[7].substring(3,7));                                                    
                                listaSedute.forEach( entry => {
                                    if( properties.verboseLog==1)
                                        console.log("COMPARISON", tmp22, entry.id);            
                                    if(tmp22.startsWith(entry.id)) {
                                        entry.uploaded= true;
                                        entry.lastUpdate= beta[5]+" "+beta[6];                                        
                                        if( properties.verboseLog==1)
                                            console.log("PR",entry);
                                    }
                                });                                
                            }                                                                                              
                        } //if undefined                                                            
                    } //fine for            
                    if( properties.verboseLog==1)        
                        console.log("WEI",listaSedute);
                    raggruppaPerAnno(listaSedute);                    
                    }
                } 
                else {                    
                    window.alert("Errore recuperando la lista dei verbali");  
                }
            }
    };

    xhr2.onerror = function (e) {
        console.error("Error 32", xhr2.statusText);
    };               
    let urlEncodedData = "idv=all";                 
    xhr2.send(urlEncodedData);
    }

    const updateUI = function(jsonData) {      
        var entireMeeting = Object.entries(jsonData);                    
        var orderMeeting = [];
        for (var i = entireMeeting.length - 1; i >= 0; i--) {
            var eachMeeting = {
                id: entireMeeting[i][0],
                order: entireMeeting[i][1]["order"],                
                date: entireMeeting[i][1]["dataSeduta"],                
                };        
            orderMeeting.push(eachMeeting);
        }        
        orderMeeting.sort((a, b) => a.order > b.order ? 1 : -1)    
        doPostVerbali(orderMeeting);
}


    useEffect(() => {      
        if(notificationAvailable === null) return;  
        if(!window.cordova){        
            //CHECK AUTHENTICATION
            var xhr = new XMLHttpRequest();                            
            xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/ping.php',true);
            xhr.withCredentials = true;
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
            xhr.onload = function (e) {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {                                      
                        if( properties.verboseLog==1)
                            console.log("OK",xhr);
                        updateSedute("Comitato",doPostSedute2, updateUI);
                } else {
                    console.error("Error 1", xhr);     
                    localStorage.clear();               
                    if( properties.verboseLog==1)                    
                        console.log("QWERTY 1",localStorage.getItem("name"));                    
                    navigate("/login");  
                }
            }
            };

            xhr.onerror = function (e) {
                console.error("Error 2", xhr);                                                
                localStorage.clear();       
                if( properties.verboseLog==1)
                    console.log("QWERTY 2",localStorage.getItem("name"));                
                navigate("/login");  
            };
            
            let urlEncodedData = null; 
            xhr.send(urlEncodedData);
        //CHECK AUTHENTICATION
        }
                    
    }, 
    //[]);
    [notificationAvailable]);



    return (
        <div>
            {loadingGen ? (
                <div style={{ width:"25%",   display: "flex", 
                marginLeft: "auto", marginRight: "auto" }}> 
                <ThreeDots color="#30720f" height='350' width='150'/>
                </div> 
            ):(
                <div className="content">          

                {
                Object.entries(meetingData)
                .sort((a, b) => b[0] - a[0]) 
                .map(([anno, documenti]) => (                                    
                    <Accordion         
                    style={{
                        backgroundColor: 'white',
                        marginBottom: '20px',
                        boxShadow: 'none',
                        border: '1px solid #ddd',
                        borderRadius: '10px',
                        position: 'relative',
                    }}
                    sx={{
                        '&:before': {
                        display: 'none',
                        },
                        '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '11px',
                        height: '100%',
                        backgroundColor: color,
                        borderTopRightRadius: '10px',
                        borderBottomRightRadius: '10px',
                        },                    
                    }} key={anno}  
                    expanded={openedYear[anno] === true}
                    onChange={() => handleChange(anno)}
                    disableGutters >
                    <AccordionSummary        
                        expandIcon={null} 
                        sx={{ paddingLeft: '30px', paddingRight: '40px' }} >      
                            
                            <p className= "textBlackBoldSedute">Verbali del {anno} </p>
                            <Box sx={{ marginLeft: 'auto' }}>
                                {openedYear[anno] ?(
                                    <ExpandLessIcon  sx={{ fontSize: '32px',  color: {color} }}/>                            
                                ):(
                                    <ExpandMoreIcon  sx={{ fontSize: '32px',  color: {color} }}/>
                                )}
                            </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <List>
                        {([...documenti]
                            //.sort((a, b) => a.order - b.order)
                            ).map((doc,index) => (
                                <Box
                                key={doc.id}
                                sx={{                              
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    padding: 2,
                                    marginBottom: 2,
                                    backgroundColor: '#fcfcfc',
                                    display: "flex",
                                    justifyContent: "space-between", 
                                    alignItems: "center",
                                }}>
                            <ListItem key={index} disablePadding>
                            {doc.lastUpdate ? (
                                <Link  style={{width:"100%",  cursor:"pointer"}} 
                                sx={{
                                    textDecorationColor: "transparent", 
                                    '&:hover': {
                                      textDecorationColor: color, 
                                    }
                                  }}
                                  onClick={() => {topicList(doc); }}
                                target="_blank" rel="noopener" underline="hover">
                                    <ListItemText sx={{ '& .MuiListItemText-primary': {color: 'black'},paddingLeft: '10px'}} primary={"Seduta del " + doc.nome} secondary={"Disponibile dal "+doc.lastUpdate}/>
                                </Link> ):(
                                    <Link  style={{width:"100%", cursor:"default"}}  underline="none" >
                                    <ListItemText sx={{'& .MuiListItemText-primary': {color: 'black'}, paddingLeft: '10px'}} primary={"Seduta del " + doc.nome} secondary={"Non ancora disponibile"}/>
                                    </Link>
                            )}                                                    
                            </ListItem>

                            {doc.lastUpdate ? ( 
                                <div>
                                    <KeyboardArrowRightIcon onClick={() => {topicList(doc); }} style={{cursor:"pointer"}} sx={{ color: '#879497' }} fontSize="large"/>
                                </div>
                                ):
                                localStorage.getItem("ruolo")=="12" ?(                                    
                                    <div>
                                    <input id={"file-upload"+index} type="file" onChange={(event)=> onFileChange(event,doc)} style={{ display: "none" }} />    
                                    <label htmlFor={"file-upload"+index}>                     
                                        <IconButton color="primary" aria-label="upload" component="span" style={{ color: "black", background: "#FFFFFF",  }}  >
                                            <PublishIcon />                        
                                        </IconButton>                                                                       
                                    </label>
                                    </div>
                            ) :
                            (<></>)  
                            }                            
                            </Box>
                        ))}
                        </List>
                    </AccordionDetails>
                    </Accordion>
                ))}
                </div>
    )}
    {alert}     
    <div>
            {dialog}        
        </div>   
    </div>     
    );
}
